// extracted by mini-css-extract-plugin
export default {"wrap":"FatalError_wrap__Pq501","errorIcon":"FatalError_errorIcon__U+Y5c","message":"FatalError_message__d1pFD","description":"FatalError_description__SUBPZ"};